import { render, staticRenderFns } from "./areaAdminPageTags.vue?vue&type=template&id=e5447356&scoped=true"
import script from "./areaAdminPageTags.vue?vue&type=script&lang=js"
export * from "./areaAdminPageTags.vue?vue&type=script&lang=js"
import style0 from "./areaAdminPageTags.vue?vue&type=style&index=0&id=e5447356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5447356",
  null
  
)

export default component.exports